export enum DataFieldType {
  String = 0,
  Boolean = 1,
  Int64 = 2,
  Double = 3
}
